<p-toast position="bottom-center"></p-toast>

<div class="card md-form-shell">
  <form
    [formGroup]="activityTypeForm"
    (ngSubmit)="saveActivityType()"
    novalidate
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="off"
  >
    <div class="card-container bg-gray-100 border-round mt-2 p-4">
      <div class="mr-5 flex align-items-center mb-3">
        <i class="pi pi-file-edit mr-2 text-3xl"></i>
        <div class="font-medium text-3xl text-900">{{ pageTitle }}</div>
      </div>

      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-sparkles"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                id="activityTypeName"
                type="text"
                pInputText
                formControlName="name"
                class="w-full"
                placeholder="Enter activity type name"
              />
              <label for="activityTypeName">Activity Type Name</label>
            </p-iftalabel>
          </p-inputgroup>
          <small *ngIf="activityTypeForm.get('name')?.invalid && activityTypeForm.get('name')?.touched" class="p-error">
            Activity Type Name is required.
          </small>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                id="activityTypeCode"
                type="text"
                pInputText
                formControlName="code"
                class="w-full"
                placeholder="Enter activity type code"
              />
              <label for="activityTypeCode">Activity Type Code</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-wallet"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                id="arAccount"
                type="text"
                pInputText
                formControlName="arAccount"
                class="w-full"
                placeholder="Enter AR account"
              />
              <label for="arAccount">AR Account</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-wallet"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                id="apAccount"
                type="text"
                pInputText
                formControlName="apAccount"
                class="w-full"
                placeholder="Enter AP account"
              />
              <label for="apAccount">AP Account</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-forward"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                id="arFuture1"
                type="text"
                pInputText
                formControlName="arFuture1"
                class="w-full"
                placeholder="Enter AR future 1"
              />
              <label for="arFuture1">AR Future 1</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-forward"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                id="arFuture2"
                type="text"
                pInputText
                formControlName="arFuture2"
                class="w-full"
                placeholder="Enter AR future 2"
              />
              <label for="arFuture2">AR Future 2</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-forward"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                id="apFuture1"
                type="text"
                pInputText
                formControlName="apFuture1"
                class="w-full"
                placeholder="Enter AP future 1"
              />
              <label for="apFuture1">AP Future 1</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-forward"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input
                id="apFuture2"
                type="text"
                pInputText
                formControlName="apFuture2"
                class="w-full"
                placeholder="Enter AP future 2"
              />
              <label for="apFuture2">AP Future 2</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      </div>
    </div>

    <div class="mt-4 flex justify-content-end gap-2">
      <p-button
        [label]="isEditMode ? 'Update Activity Type' : 'Save Activity Type'"
        type="submit"
      ></p-button>
      <p-button
        label="Cancel"
        styleClass="p-button-secondary"
        type="button"
        (onClick)="cancel()"
      ></p-button>
    </div>
  </form>
</div>
